<template>
  <div class="client-card border"
       v-if="vehicle"
       :class="!vehicle.calc.result ? 'border-danger border-opacity-50' : ''"
       @click="setSelectedVehicle(key)"
  >
    <div class="client-card__panel">
      <i class="ki-duotone ki-truck fs-3x text-primary">
        <span class="path1"></span>
        <span class="path2"></span>
        <span class="path3"></span>
        <span class="path4"></span>
        <span class="path5"></span>
      </i>
      <div class="ms-4">
        <div class="fs-6 fw-bolder text-gray-700">{{ vehicle.vin }}</div>
        <div v-if="!vehicle.calc.result" class="fs-8 text-danger opacity-75">Ошибка при получении премии</div>
        <div v-else class="fs-8 text-gray-400">
          {{ vehicle.color+' '+vehicle.mark+' '+vehicle.model+' '+vehicle.year  }}
        </div>
      </div>
      <div class="card_change" v-if="!changeDisabled">
        <slot name="change"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VehicleOneCCard',
  props: {
    selectedClient: 0,
    vehicle: {
      type: Object,
      default: null
    },
    key: {
      type: Number,
      default: 0
    },
    isDeleted: {
      type: Boolean,
      default: false
    },
    changeDisabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['setSelectedVehicle', 'deleteVehicle'],
  methods: {
    setSelectedVehicle(key) {
      this.$emit('setSelectedVehicle', key)
    },
    deleted(key) {
      this.$emit('deleteVehicle', key)
    }
  }
}
</script>

<style></style>